<form *ngIf="form" [formGroup]="form">
  <dx-number-box
    formControlName="cost"
    formField
    required
    [label]="'common.cost' | translate | ucfirst"
  />
  <dx-date-box
    formControlName="date"
    formField
    required
    type="date"
    [label]="'common.date' | translate | ucfirst"
  />
</form>

